// Redesign shell: menu dialog, header dropdowns (SHOP, a link with sub-links), bag count, screen-reader announcer, FAQ deep links and product tile swatches.
// Listeners sit on the document and look elements up as they fire, so a header the theme editor re-renders still works.
const navMenus = () => document.querySelectorAll('.rd .desktop-nav > details');
// The menu photo is lazy (sections/stally-rd-header.liquid); eager starts its download even inside the closed menu.
const loadMenuPhoto = () => {
  const photo = document.getElementById('menu-photo');
  if (photo) photo.loading = 'eager';
};

document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const opener = event.target.closest('[data-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.open);
    if (dialog?.id === 'menu-dialog') loadMenuPhoto();
    for (const nav of navMenus()) {
      if (!nav.open) continue;
      nav.querySelector('summary').focus();
      nav.open = false;
    }
    document.querySelectorAll('.rd dialog[open]').forEach(open => { if (open !== dialog) open.close(); });
    if (dialog && !dialog.open) dialog.showModal();
  }
  event.target.closest('[data-close]')?.closest('dialog')?.close();
  if (event.target.closest('#menu-dialog a')) document.getElementById('menu-dialog').close();
});

// Product tile swatches (snippets/stally-rd-card.liquid): a color shows its photo and points the tile at that color;
// a hat's color is its own product, so its name and price come with it.
document.addEventListener('click', event => {
  // buttons only: a tile's single color is a plain span.swatch with no link to switch to
  const swatch = event.target instanceof Element ? event.target.closest('.pg-tile button.swatch') : null;
  if (!swatch?.dataset.href) return;
  const tile = swatch.closest('.pg-tile');
  const link = tile.querySelector('.pg-card');
  const photo = link.querySelector('.pg-card-media img');
  if (photo && swatch.dataset.src) Object.assign(photo, { srcset: swatch.dataset.srcset, src: swatch.dataset.src, alt: swatch.dataset.alt });
  link.href = swatch.dataset.href;
  if (swatch.dataset.title) {
    link.querySelector('.pg-card-meta strong').textContent = swatch.dataset.title;
    link.querySelector('.pg-card-meta > span').textContent = swatch.dataset.price;
  }
  tile.querySelectorAll('.swatch').forEach(button => button.setAttribute('aria-pressed', String(button === swatch)));
});

// Where the menu button shows, the photo loads once the page has, ahead of a first open.
addEventListener('load', () => {
  if (!document.querySelector('.rd .menu-trigger')?.getClientRects().length) return;
  (window.requestIdleCallback || setTimeout)(loadMenuPhoto);
}, { once: true });

const closeOutside = event => {
  for (const nav of navMenus()) if (nav.open && !nav.contains(event.target)) nav.open = false;
};
document.addEventListener('pointerdown', closeOutside);
document.addEventListener('focusin', closeOutside);
document.addEventListener('keydown', event => {
  const nav = event.target instanceof Element ? event.target.closest('.rd .desktop-nav > details') : null;
  if (event.key === 'Escape' && nav?.open) {
    event.preventDefault();
    nav.open = false;
    nav.querySelector('summary').focus();
  }
});
// The desktop nav hides at tablet widths; a dropdown left open there would float with no summary.
function watchHeader() {
  const header = document.querySelector('.rd .shop-header');
  if (!header) return;
  new ResizeObserver(() => {
    for (const nav of navMenus()) if (!nav.querySelector('summary').getClientRects().length) nav.open = false;
  }).observe(header);
}
watchHeader();
document.addEventListener('shopify:section:load', event => {
  if (event.target.querySelector('.shop-header')) watchHeader();
});

// Safari has no <dialog closedby>: a click on the backdrop of any redesign dialog closes it.
if (!('closedBy' in HTMLDialogElement.prototype)) {
  document.addEventListener('click', event => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('.rd dialog[closedby="any"]')) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
}

// Bag count sources: redesign scripts' 'stally:cart' (detail = the Ajax API cart) and Concept's theme.js pubsub events.
function setBagCount(count) {
  const badge = document.getElementById('bag-count');
  if (!badge || !Number.isInteger(count)) return;
  badge.textContent = count;
  badge.closest('a')?.setAttribute('aria-label', `Bag, ${count} ${count === 1 ? 'item' : 'items'}`);
}
document.addEventListener('stally:cart', event => setBagCount(event.detail?.item_count));
if (window.theme?.pubsub) {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, event => {
    if (!event.cart?.errors) setBagCount(event.cart?.item_count);
  });
}

// One status region outside every section: a live region replaced along with its section isn't announced.
const announcer = document.createElement('p');
announcer.id = 'rd-announcer';
announcer.setAttribute('role', 'status');
announcer.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap';
document.body.append(announcer); // created at load: a region added with its first message is often not read
document.addEventListener('stally:announce', event => {
  const region = announcer;
  region.textContent = '';
  requestAnimationFrame(() => { region.textContent = String(event.detail || ''); });
});

// FAQ: a link to #<question> opens that question (ids are handleized headings, so no decoding).
const openHash = () => {
  const target = location.hash ? document.getElementById(location.hash.slice(1)) : null;
  if (target?.matches('.rd details')) target.open = true;
};
window.addEventListener('hashchange', openHash);
openHash();
